import React, { Component } from 'react'; //different
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openKey: null
        };
    }
    toggle = (key) => {
        this.setState((prev) => ({
            openKey: prev.openKey === key ? null : key
        }));
    };
    render() {

        const isOpen = true;
        const keyid = this.state.openKey;
        return (
            <>
                <main className="flex-1 overflow-y-auto flex flex-col justify-start no-scrollbar pb-24 z-40"   >
                    <div
                        className="relative w-full min-h-full pt-2 flex flex-col justify-start items-center pb-2"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <div className="relative w-full h-[48px] flex items-center px-2 py-3 md:px-14">
                            <div>
                                <button className="flex items-center"
                                    type="button"
                                    onClick={(e) => this.props.onNavigate(
                                        `/`
                                    )}>
                                    <div className=" relative w-[32px] h-[32px] md:w-[36px] md:h-[36px] ">
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "absolute",
                                                inset: 0
                                            }}
                                        >
                                            <img
                                                src="/build/web/igame-index-lobby-wm/img/back.png"
                                                decoding="async"
                                                data-nimg="fill"
                                                style={{
                                                    filter: "hue-rotate(191deg) brightness(1)",
                                                    position: "absolute",
                                                    inset: 0,
                                                    boxSizing: "border-box",
                                                    padding: 0,
                                                    border: "none",
                                                    margin: "auto",
                                                    display: "block",
                                                    width: 0,
                                                    height: 0,
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%"
                                                }}
                                            />
                                        </span>
                                    </div>
                                </button>
                            </div>
                            <div className="flex-grow text-center font-[700] leading-[1.3] text-[15px] xs:text-[17px] md:text-[25px] truncate">
                                แนะนำการใช้งาน
                            </div>
                        </div>
                        <div className="w-full min-h-[29px] flex gap-3 justify-between items-center pt-1 pb-2 border-b border-white/5 px-4 md:px-20 overflow-auto no-scrollbar">
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    ทั้งหมด
                                </div>
                                <div
                                    className="absolute -bottom-2 left-2 right-2 h-[3px] bg-[#EE5F28]"
                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                />
                            </div>
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    การฝาก - ถอน
                                </div>
                            </div>
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    กิจกรรม
                                </div>
                            </div>
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    การเข้าเล่น
                                </div>
                            </div>
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    สร้างรายได้เครือข่าย
                                </div>
                            </div>
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    สิทธิประโยชน์
                                </div>
                            </div>
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    ค่าคืนยอดเสีย / คืนยอดเสีย
                                </div>
                            </div>
                            <div className="w-fit px-1 relative snap-start scroll-mx-4 shrink-0 whitespace-nowrap cursor-pointer">
                                <div className="font-[700] leading-[16px] text-[11px] xs:text-[14px]">
                                    เกิดปัญหาในการเล่นเกม?
                                </div>
                            </div>
                        </div>
                        <div className="w-full" />
                        <div className="w-full">
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    การฝากเงิน
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(1)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 1 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ฝากเงินแบบ โอนผ่านธนาคาร
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 1 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ไปที่เมนู
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            <strong> </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>“ฝาก”</strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            {" "}
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            มุมซ้ายล่าง รูปสัญลักษณ์กระเป๋าเงิน
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950597316-550b57dd-25fe-46d4-81f0-350cff45e4d3.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            เลือกวิธีฝากเงิน เลือก
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            <strong> </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>“โอนเงินผ่านธนาคาร”</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949672007-9acefef2-3b08-4b75-b3c6-e91d78774c24.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>กรอกจำนวนที่ต้องการฝาก</strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            {" "}
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            (ขั้นต่ำ : 20 / สูงสุด : 10,000,000)
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950605548-322746c9-ee2b-45d2-b62d-99613996160d.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            กด
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            {" "}
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>ยืนยัน</strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            {" "}
                                                            ยอดที่ต้องการฝาก
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img
                                                src="https://cdn.zabbet.com/_INIT/user-guides/1725948379444-c88a936e-9761-4431-baa2-4cae6df0f704.png"
                                                data-tried="true"
                                            />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                หน้ารายละเอียดฝากเงิน จะแจ้ง
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>เลขบัญชีที่ต้องโอน</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                สามารถ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>คัดลอก</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ได้เลย
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950613932-a4c1d0cd-3976-4fbd-afe9-535a77a12561.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                รายการฝาก
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#38761d"
                                                                }}
                                                            >
                                                                <strong>สำเร็จ </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ขอให้เพลิดเพลินกับทุกความสนุกครบวงจร
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950617823-53231dbd-b320-4497-b4d8-18190a5c367f.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(2)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 2 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ฝากเงินแบบ โอนผ่าน QR Payment{" "}
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 2 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ไปที่เมนู
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                <strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>“ฝาก”</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                มุมซ้ายล่าง รูปสัญลักษณ์กระเป๋าเงิน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949592108-6d8b0ecf-fed2-4a50-b3bd-0ba0ae0571a4.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เลือกวิธีฝากเงิน เลือก<strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>“QR Payment”</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949603610-c3b680e6-38a9-4f3e-806e-cd1c68e084b4.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>กรอกจำนวนที่ต้องการฝาก</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                (ขั้นต่ำ : 20 / สูงสุด : 10,000,000)
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949616944-fa5ce5e0-d168-4ddd-87e1-d6b896b4daf4.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                กด{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ยืนยัน</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                ยอดที่ต้องการฝาก
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949624888-e34d3e8a-7fec-465c-a6a9-79ed70795a50.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ดาวน์โหลด หรือ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>แคปภาพหน้าจอ</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เพื่อสแกนโอนผ่าน QR Code
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949631390-999a2d7d-da36-4670-bc85-8de37bc94c3d.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เมื่อทำรายการโอนผ่านแอปธนาคารแล้ว กด{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ยืนยันการโอน</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                ยอดเงินจะเข้าทันที
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                รายการฝาก{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#38761d"
                                                                }}
                                                            >
                                                                <strong>สำเร็จ </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ขอให้เพลิดเพลินกับทุกความสนุกครบวงจร
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725948835529-db811e55-fc92-414f-9908-c79779bad934.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(3)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 3 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ฝากเงินแบบ ฝากจุดทศนิยม
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 3 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ไปที่เมนู
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                <strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>“ฝาก”</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                มุมซ้ายล่าง รูปสัญลักษณ์กระเป๋าเงิน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949040801-f0f698e3-55cc-47aa-ae95-754c7d97d293.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เลือกวิธีฝากเงิน เลือก<strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>“ฝากจุดทศนิยม” </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                แล้วใส่
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong> จำนวนเงินที่ต้องการฝาก</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949035931-8db7936b-5249-4a89-a7d1-3d22f1a29d73.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ดาวน์โหลด หรือ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>แคปภาพหน้าจอ</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เพื่อสแกนโอนเงิน&nbsp;
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>หมายเหตุ :</strong>{" "}
                                                                ระบบจะสุ่มทศนิยมให้ใหม่ทุกครั้งที่แจ้งฝาก
                                                                รบกวนทำรายการภายใน 15 นาที&nbsp;
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                และยอดเงินจะเข้าตามจำนวนตามทศนิยม ไม่ถูกหักเ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                ศษ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949050423-35817754-2840-4805-a646-fee1d6dd3792.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                รายการฝาก{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#38761d"
                                                                }}
                                                            >
                                                                <strong>สำเร็จ </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ขอให้เพลิดเพลินกับทุกความสนุกครบวงจร
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949053989-7750ac0e-75fb-4448-8a8e-6d5cc980a1b1.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(4)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 4 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            วิธีการฝากแบบ TrueWallet
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 4 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ไปที่เมนู<strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>“ฝาก”</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                มุมซ้ายล่าง รูปสัญลักษณ์กระเป๋าเงิน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949070466-b75a11a0-ab65-4714-9dfb-73bed397a157.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เลือกวิธีฝากเงิน เลือก
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                <strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>“True Wallet”</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949213531-7243fcb2-3b37-48c9-8eb8-cafb36defa35.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ใส่
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>จำนวนเงินที่ต้องการฝาก</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                แล้วกด ยืนยัน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949221400-84b336f7-60a2-405c-a28c-d2971a82e3a3.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                คัดลอกหมายเลข<strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>True Wallet</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                แล้วโอนผ่าน
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>แอป ทรู มันนี่ วอลเล็ท</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong> </strong>เท่านั้น!!
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                รอยอดเงินอัปเดต ภายใน 30 วินาที หากยังไม่เข้า
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>แนบสลิป</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                ที่โอนเพื่อแจ้งเจ้าหน้าที่คำเตือน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>เบอร์สมัคร</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                และเบอร์
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ทรู มันนี่ วอลเล็ท</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ต้องเป็น
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>เบอร์เดียวกัน!!</strong>
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ต้องใช้แอปทรู มันนี่ วอลเล็ท ในการโอนเท่านั้น
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ห้ามใช้บัญชีธนาคารโอนเข้า!!</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949372643-2e263ab6-2752-409e-98b2-aa570fdbfb75.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(5)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 5 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ยอดไม่เข้าทันที ทำยังไงดี?
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 5 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เมื่อแจ้งฝากแล้วตามขั้นตอนแล้ว ยอดยังไม่เข้า
                                                                <strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ให้รอ 30 วินาที ระบบจะขึ้นให้แนบสลิป</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949482835-5adffc1e-f42c-42bf-a265-7a26e6475f2b.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เมื่อแนบสลิปแล้ว กด{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ยืนยันสลิป </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ยอดจะเข้าทันที
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949533328-60510d4c-fcc8-41cc-b6b2-1a67058ceacd.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                รายการฝาก
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#38761d"
                                                                }}
                                                            >
                                                                <strong>สำเร็จ </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ขอให้เพลิดเพลินกับทุกความสนุกครบวงจร
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949537894-b8f912e4-066e-46f1-8a35-2ded8aa41e40.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    การถอนเงิน
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(6)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 6 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            การถอนเงิน
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 6 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ไปที่เมนู
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                <strong> </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>“ถอน”</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                มุมขวาล่าง รูปสัญลักษณ์เงิน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949688831-9388e547-156e-4f6c-b86b-d0ccb709a986.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul style={{ listStyleType: "disc" }}>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ใส่จำนวนเงินที่ต้องการถอน (ขั้นต่ำ : 100 / สูงสุด :
                                                                2,000,000)
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949728325-2ffda935-c515-48e1-91a8-cb8662dbf5f8.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                รายการ{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ถอนเงินสำเร็จ</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949812662-ce7de4c7-0ee9-4f86-8d28-ccbfb0208ed6.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    โปรโมชั่น
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(7)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 7 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            โปรโมชั่นแนะนำ
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 7 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            รวบรวมทุกโปรโมชั่นยอดฮิต ทั้งโปรโมชั่นสมาชิกใหม่ และเก่า
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949902046-da9c8596-bde1-404c-9f4d-161445ea1825.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    รวบรวมทุกกิจกรรม
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(8)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 8 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            กิจกรรมทายผลคืออะไร?
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 8 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>กิจกรรมทายผล</strong> คือ
                                                                กิจกรรมที่ให้ลูกค้าได้ร่วมสนุกทายผลต่างๆ เช่น{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>
                                                                    ทายผลการแข่งขันกีฬา ทายผลมวย ทายผลหวย
                                                                    และทายผลอื่นๆอีกมากมาย
                                                                </strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                เรามีกิจกรรมให้เลือกหลากหลายรูปแบบสามารถกดเข้าเลือกกิจกรรมทายผลที่คุณต้องการได้เลย
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(9)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 9 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            สิ่งที่ต้องทำก่อนทายผล
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 9 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>สมัครสมาชิก :</strong> หากยังไม่ได้เป็นสมาชิก
                                                                ให้ทำการสมัครสมาชิกกับเว็บก่อน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>ทำตามกติกา :</strong>{" "}
                                                                อ่านกติกาของกิจกรรมแต่ละอย่างให้ละเอียด
                                                                เพื่อให้เข้าใจเงื่อนไขในการเข้าร่วมและการรับรางวัล
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>ส่งคำตอบ :</strong> ส่งคำตอบทายผลตามที่กำหนด
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(10)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 10 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            เข้าร่วมกิจกรรมทายผลยังไง?
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 10 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            เมื่อเป็นสมาชิกกับทางเว็บเเล้ว
                                                            ลูกค้าจะเข้าร่วมกิจกรรมอัตโนมัติ
                                                            สามารถเข้าร่วมกิจกรรมที่ต้องการได้ทันที
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(11)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 11 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            การประกาศรางวัล
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 11 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                เมื่อทางเว็บเปิดให้เข้าร่วมกิจกรรม
                                                                สามารถติดตามผลประกาศรางวัลได้ที่หน้าเว็บ
                                                                หรือสอบถามเพิ่มเติมกับทางแอดมิน
                                                                เพื่อติดตามผลรางวัลได้เลย
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(12)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 12 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ล็อคอินประจำวัน / ภารกิจ{" "}
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 12 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950126219-3d1fa884-b89f-4c82-be99-0c0426dccf25.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                <u>กิจกรรมล็อคอินประจำวัน</u>
                                                            </strong>
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                กิจกรรมสำหรับสมาชิกที่
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ล็อคอินประจำทุกวัน</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                เพื่อรับรางวัลในเเต่ละวัน&nbsp;
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                คลิกเลือกวัน เพื่อตรวจสอบเงื่อนไขกิจกรรม
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950174653-5c573032-6f58-43b4-8176-fd26f3628cf0.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ตรวจสอบเงื่อนไขจากหน้าต่างป๊อบอัพ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950205493-ff304597-3a74-4b0e-be6d-8df00b26c752.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                <u>ภารกิจ</u>
                                                            </strong>
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                เลื่อนลงจะพบกับหน้า
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>รายการภารกิจ</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950254985-cf9f3ac8-9b8b-40c6-ac3d-fca00d04e70c.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                คลิกที่ภารกิจ เพื่อ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ตรวจสอบเงื่อนไข</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ได้เลย&nbsp;
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ภารกิจสำเร็จ</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                กดรับรางวัลตามเงื่อนไขได้ทันที!!
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950289415-bc863afd-b5ab-432b-9d61-6922deb66161.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ตรวจสอบสถานะรางวัลจากสัญลักษณ์ รูปเหรียญ หรือ ตั๋งรางวัล
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950352799-f66bd954-e1d2-4330-bbec-fdab6835b4ad.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                นำรางวัลที่ได้{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>หมุนวงล้อเสี่ยงโชค</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ลุ้นรางวัลใหญ่
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(13)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 13 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ขั้นตอน : ทายผลบอล
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 13 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950536122-e5041c25-59ba-4cb8-90dd-97b73745bde1.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ทายถูกจะได้รับ{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>รางวัล 500 บาท</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                จำกัดจำนวน 20 รางวัล&nbsp;
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                (หากมีสมาชิกตอบถูกเกิน 20 คน จะทำการสุ่มผู้โชคดี)
                                                            </span>
                                                            <br />
                                                            &nbsp;
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950686602-4c130117-045d-4a78-9e24-7e30a386e60b.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                หากทายผลแบบ{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>เลือกฝั่ง แพ้ - ชนะ</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ใส่สกอร์ที่ต้องการทายได้เลย
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950731044-90420115-91b7-43a6-bce0-b98ab2e3d4a1.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                หากทายผลแบบ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ผลเสมอ</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                ต้องเลือก ทีมที่ยิงก่อน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950810583-027544d2-32e9-436f-95e5-2e4e33f769df.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                หากทายผล{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>เสมอ 0 - 0</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                คลิกที่ เสมอ ไม่ต้องเลือกทีมที่ยิงก่อน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950779786-07076102-49cb-41ae-baed-3fa5d96261fb.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ยืนยันตัวเลือก</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                แล้วรอลุ้นกันได้เลย !!
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(14)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 14 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ขั้นตอน : ทายผลมวย
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 14 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950866784-d6df6c34-20db-4cb8-8b34-0747d0967464.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                หากสมาชิกทายถูกจะได้รับ รางวัล 300 บาท จำกัดจำนวน 30
                                                                รางวัล&nbsp;
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                (หากมีสมาชิกตอบถูกเกิน 30 คน จะทำการสุ่มผู้โชคดี)
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <br />
                                                        &nbsp;
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ทายผล เลือกฝั่งชนะ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950903281-9cb887a5-5884-4231-8a5b-50b3c18151cf.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                หากเลือก ชนะคะแนน กดยืนยันตัวเลือกทายผลได้เลย
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950925693-697fa44b-dba6-4602-a645-21437141fe6c.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span style={{ color: "hsl(0, 0%, 100%)" }}>
                                                                หากเลือก ชนะน็อค ต้องเลือกยกที่น๊อค ก่อนยืนยันตัวเลือก
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ยืนยันตัวเลือก</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                แล้วรอลุ้นกันได้เลย !!
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(15)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 15 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ขั้นตอน : ทายผลหวย
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 15 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950990047-08f115ae-a9c3-4b6d-9d71-8697b326d221.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ทายถูก 3 ตัวท้าย</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                รับ 10,000 บาท&nbsp;
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ทายถูก 2 ตัวล่าง</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                รับ 1,000 บาท
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ทายผลให้ครบทั้ง 3 ตัวบน และ 2 ตัวล่าง
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951018864-199359f3-a6e4-498c-a571-a9fbd9b96c2a.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ตรวจสอบตัวเลข
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                ยืนยันตัวเลือก
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                แล้วรอลุ้นกันได้เลย !!
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951094888-87b69dc9-4180-48be-83fa-3d1087d09fb8.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    ข่าวสาร
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(16)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 16 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ติดตามข่าวสาร
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 16 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            สมาชิกสามารถติดตามอัปเดตใหม่ๆก่อนใคร ได้ที่นี่
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725949964104-ebd0047a-fc25-4a50-b5e0-752b7dfc3cd4.png" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725950084108-f4a34832-d78f-42e4-a1fb-fea70a676781.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    การเข้าเล่นคาสิโน
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(17)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 17 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            เข้าเล่น : คาสิโน
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 17 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951194797-f3f46b8a-a24d-4f05-83d3-3cba2ef033cd.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <i>
                                                                <strong>
                                                                    ผู้เล่นใหม่จะเล่นบาคาร่า แทงยังไงและกฎเป็นยังไง?
                                                                </strong>
                                                            </i>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725945805048-39c64261-64d9-40ad-a2c6-657711a0ca90.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>บาคาร่า</strong> เป็นเกมไพ่ที่เล่นง่ายมาก ๆ
                                                                เป้าหมายคือการทายผลว่า ฝั่ง
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#0000ff"
                                                                }}
                                                            >
                                                                <strong>Player (ผู้เล่น)</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                หรือ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>Banker (เจ้ามือ)</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                จะได้ไพ่ที่มี{" "}
                                                                <i>
                                                                    <strong>แต้มใกล้เคียง 9 มากที่สุด</strong>
                                                                </i>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                <u>กติกาเบื้องต้น:</u>
                                                            </strong>
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>แจกไพ่ :</strong> แต่ละฝั่งจะได้รับไพ่ 2-3 ใบ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>นับแต้ม :</strong>{" "}
                                                                แต้มของไพ่หน้าจะเท่ากับค่าของหน้าไพ่ (A = 1, J, Q, K =
                                                                10) ถ้าแต้มเกิน 9 จะนับเฉพาะหลักหน่วย (เช่น 7 + 8 = 15
                                                                นับเป็น 5)
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>ฝั่งที่ได้แต้มใกล้เคียง 9 มากที่สุด</strong>{" "}
                                                                จะเป็นฝ่ายชนะ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                <u>การเดิมพัน</u>
                                                            </strong>
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#0000ff"
                                                                }}
                                                            >
                                                                <strong>Player :</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                เดิมพันว่าฝั่งผู้เล่นจะชนะ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>Banker :</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                เดิมพันว่าฝั่งเจ้ามือจะชนะ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#38761d"
                                                            }}
                                                        >
                                                            <strong>Tie :</strong>{" "}
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            เดิมพันว่าทั้งสองฝั่งจะมีแต้มเท่ากัน (อัตราจ่ายสูง
                                                            แต่โอกาสเกิดน้อย)
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <h4>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <i>
                                                                <strong>ตัวอย่าง การนับแต้มไพ่</strong>
                                                            </i>
                                                        </span>
                                                    </h4>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725945808687-b3179477-b18b-41bc-af9f-d3c12eeba8c6.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เลือกทายผลว่า ฝั่ง{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#0000ff"
                                                                }}
                                                            >
                                                                <strong>Player (ผู้เล่น)</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                หรือ
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>Banker (เจ้ามือ)</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                &nbsp;
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ฝั่งใดจะได้ไพ่ที่มี{" "}
                                                                <i>
                                                                    <strong>แต้มใกล้เคียง 9 มากที่สุด</strong>
                                                                </i>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725945811140-3a0c0f17-2f15-487e-823f-01ee3f54b6cc.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>นับแต้ม</strong> :
                                                                แต้มของไพ่หน้าจะเท่ากับค่าของหน้าไพ่ (A = 1, J, Q, K =
                                                                10) ถ้าแต้มเกิน 9 จะนับเฉพาะหลักหน่วย (เช่น 10 + 8 = 18
                                                                นับเป็น 8) ฝั่งที่ได้แต้มใกล้เคียง 9 มากที่สุด
                                                                จะเป็นฝ่ายชนะ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>
                                                                    <u>จากรูป</u>&nbsp;
                                                                </strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p style={{ marginLeft: "36pt" }}>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#0000ff"
                                                            }}
                                                        >
                                                            <strong>Player (ผู้เล่น) </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ได้ไพ่ 6 และ Q แต้มได้คือ 6+10 = 16 เท่ากับได้ 6 แต้ม
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>Banker (เจ้ามือ) </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ได้ไพ่ J, 10 และ 8 แต้มที่ได้คือ 10+10+8 = 18 เท่ากับได้ 8
                                                            แต้ม&nbsp;
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ผลคือ
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            {" "}
                                                        </span>
                                                        <span
                                                            style={{ backgroundColor: "#ff0000", color: "#ffffff" }}
                                                        >
                                                            <strong>Banker (เจ้ามือ) ชนะ</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(18)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 18 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            เข้าเล่น : สล็อต
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 18 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <h4>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <i>
                                                                <strong>
                                                                    สล็อตไม่มีฟีเจอร์สปิน กับ มีฟีเจอร์สปิน
                                                                    แตกต่างกันตรงไหน?
                                                                </strong>
                                                            </i>
                                                        </span>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>สล็อตเกมที่ไม่มีฟีเจอร์สปิน</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725945868614-6c03c6a4-7b31-4116-a3be-d2f2627ef4c8.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>รูปแบบการเล่น :</strong> เกมสล็อตแบบดั้งเดิม
                                                                มักจะเน้นที่การหมุนวงล้อเพื่อให้สัญลักษณ์เรียงกันตามไลน์ที่กำหนด
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>โอกาสในการชนะ :</strong>{" "}
                                                                โอกาสในการชนะรางวัลใหญ่จะขึ้นอยู่กับการสุ่มของเกมเป็นหลัก
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>สล็อตเกมที่มีฟีเจอร์สปิน</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725945905758-bacfcc77-5294-4594-a00e-7c5e73f15b2c.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>รูปแบบการเล่น :</strong>{" "}
                                                                นอกจากการหมุนวงล้อตามปกติแล้ว
                                                                ยังมีฟีเจอร์พิเศษอย่าง&nbsp;
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ฟรีสปิน (Free Spin)</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                ที่เปิดโอกาสให้ผู้เล่นได้หมุนวงล้อฟรีๆ หลายรอบ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>โอกาสในการชนะ :</strong>{" "}
                                                                มีโอกาสในการชนะรางวัลมากขึ้น
                                                                เนื่องจากได้หมุนวงล้อฟรีหลายรอบ และ
                                                            </span>
                                                            <br />
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                บางเกมยังมีตัวคูณเงินรางวัลในระหว่างฟรีสปินอีกด้วย
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>โบนัสพิเศษ :</strong>{" "}
                                                                เนื่องจากมีโอกาสที่จะได้รับฟีเจอร์พิเศษอื่นๆ เพิ่มเติม
                                                                เช่น Wild, Scatter หรือตัวคูณเงินรางวัล
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                <u>ฟีเจอร์พิเศษในเกมสล็อต</u>
                                                            </strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            นอกจากรูปแบบการเล่นที่หลากหลายแล้ว
                                                            เกมสล็อตยังมีฟีเจอร์พิเศษต่างๆ
                                                            ที่ช่วยเพิ่มความสนุกสนานและโอกาสในการชนะรางวัล เช่น
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>Wild :</strong>{" "}
                                                                เป็นสัญลักษณ์พิเศษที่สามารถแทนที่สัญลักษณ์อื่นๆ
                                                                ได้เกือบทุกสัญลักษณ์
                                                                เพื่อช่วยให้คุณสร้างชุดค่าผสมที่ชนะได้ง่ายขึ้น
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>Scatter :</strong>{" "}
                                                                เป็นสัญลักษณ์พิเศษที่เมื่อปรากฏตามจำนวนที่กำหนด
                                                                จะทำให้คุณได้รับฟรีสปินหรือโบนัสเกม
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>Free Spins :</strong>{" "}
                                                                เป็นฟีเจอร์ที่ทำให้คุณได้หมุนวงล้อฟรี
                                                                โดยไม่ต้องใช้เงินเดิมพัน
                                                                และยังมีโอกาสได้รับรางวัลพิเศษเพิ่มเติม
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>Multiplier :</strong>{" "}
                                                                เป็นตัวคูณที่ช่วยเพิ่มจำนวนเงินรางวัลที่คุณได้รับ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(19)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 19 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            เข้าเล่น : ยิงปลา
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 19 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951275157-96703713-8436-483a-babb-b33190090e13.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(38)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 38 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            เข้าเล่น : กีฬา
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 38 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951310883-57656c05-1a45-47af-a069-1805f7b45295.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(20)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 20 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            เข้าเล่น : ไพ่
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 20 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951319786-8f40152b-9fb0-4e32-b583-ca354cd14e95.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(21)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 21 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            เข้าเล่น : หวย
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 21 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951332965-bae68489-1aae-4cfd-aef8-8646880001f2.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    ระบบสร้างรายได้เครือข่าย
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(22)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 22 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            สร้างรายได้เครือข่าย
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 22 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                สร้างรายได้ง่ายๆ เพียงคัดลอกลิงก์ส่งให้เพื่อนเข้ามาสมัคร
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ทุกยอดเล่นไม่ว่าจะ แพ้หรือชนะ
                                                                จะถูกคิดเป็นรายได้ทั้งหมดให้กับผู้แนะนำ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951743245-bf9fcf7f-b349-43cf-9a3c-eb1665711175.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(23)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className="text-xs ml-2 mr-3 xs:ml-4"
                                        >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ถอนรายได้เครือข่าย (แนะนำเพื่อน)
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 23 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ถอนขั้นต่ำที่{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>300 บาท</strong>
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ยอดถอนจะอยู่ที่
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>กระเป๋าหลัก</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                สามารถนำรายได้เข้าเล่น หรือถอนใช้ได้เลย
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951507389-a73fa65c-c728-412b-bc37-2be756464292.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>สร้างรายได้เครือข่าย</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951560996-1015369b-f9c4-43f6-b38b-4d3902628240.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                สร้างรายได้ง่ายๆ เพียงคัดลอกลิงก์ส่งให้เพื่อนเข้ามาสมัคร
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ทุกยอดเล่นไม่ว่าจะ แพ้หรือชนะ
                                                                จะถูกคิดเป็นรายได้ทั้งหมดให้กับผู้แนะนำ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(24)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 24 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            รับชมคลิป วิธีการสร้างเครือข่าย{" "}
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 24 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951685434-e57a246a-db49-4e49-a5db-416b7213fd89.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>รายได้จากยอดเล่นของเพื่อนนับอย่างไร?</strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                ค่าคืนยอดเสียจากยอดเล่นของเพื่อนนับตามเกมต่างๆ
                                                                โดยมีวิธีการนับดังนี้
                                                            </strong>
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                <u>ตัวอย่าง</u>
                                                            </strong>
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>• สมาชิกขั้นที่ 1 :</strong>&nbsp;
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            หากมีสมาชิก 1 ท่าน ลงเดิมพัน 10,000 บาท&nbsp;
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ท่านจะได้รับค่าคืนยอดเสีย 0.5% คิดเป็นเงิน 50 บาท
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>• สมาชิกขั้นที่ 2 :&nbsp;</strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            หากมีสมาชิก 1 ท่าน ลงเดิมพัน 10,000 บาท&nbsp;
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ท่านจะได้รับค่าคืนยอดเสีย 0.05% คิดเป็นเงิน 5 บาท
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                <u>มีวิธีการจ่ายรายได้แนะนำเพื่อนอย่างไร?</u>
                                                            </strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ค่าคืนยอดเสียจะจ่ายไปยังบัญชีของท่านโดยอัตโนมัติเมื่อเเจ้งการถอน
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            1. เมื่อลูกข่ายของท่านมียอดเล่นเสีย
                                                            ท่านจะได้รับโบนัสจากยอดเล่นเสียนั้นโดยอัตโนมัติทันที&nbsp;
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ซึ่งหากท่านไม่กดรับ เงินโบนัสที่ได้นั้นก็จะยังคงค้างอยู่
                                                            โดยไม่หายไปแน่นอน
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,75%,60%)"
                                                            }}
                                                        >
                                                            <strong>
                                                                (แต่หากมีการกดรับโปรโมชั่น
                                                                ท่านจะไม่สามารถรับโบนัสได้เพื่อป้องกันการทุจริต)
                                                            </strong>
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            2. หากลูกข่ายของท่านมีการเดิมพัน บาคาร่า/สล็อต/กีฬา
                                                            เมื่อมียอดเดิมพันไม่ว่าจะได้หรือเสีย&nbsp;
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            ระบบจะคิดรายได้ให้ท่าน 0.5% โดยอัตโนมัติทันที
                                                            แต่ท่านต้องกดรับค่าคืนยอดเสียก่อน&nbsp;
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            จึงจะสามารถรับโบนัสได้
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <br />
                                                        &nbsp;
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    สิทธิประโยชน์ลูกค้าเเต่ระดับ
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(25)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 25 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            วิธีการตรวจสอบระดับ
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 25 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ไปที่โปรไฟล์ กดที่{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ขีด 3 ขีด</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                {" "}
                                                                มุมซ้ายบน
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725940956126-425ad742-1346-4741-81f3-b98348345ae8.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เลือกที่{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>ระดับสมาชิก VIP</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725940917720-a3a962c5-d862-4030-8f74-989cc7141b49.png" />
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(26)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 26 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ระดับ Silver
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 26 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725946973702-2257bdfa-9bd7-47e9-b9a7-06db99c4ccbf.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ol>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ยอดถอนสูงสุดต่อวัน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                สิทธิ์เข้าร่วมกิจกรรมต่างๆ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษวันเกิด
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษเลื่อนระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                คืนเงินพิเศษ
                                                            </span>
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(27)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 27 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ระดับ Gold
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 27 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725946979745-aa2b9bf0-d320-4528-a073-72556e75e3e7.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ol>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ยอดถอนสูงสุดต่อวัน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                สิทธิ์เข้าร่วมกิจกรรมต่างๆ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษวันเกิด
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                โบนัสรักษาระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษเลื่อนระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษตามเทศกาล
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                คืนเงินพิเศษ
                                                            </span>
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(28)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 28 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ระดับ Platinum
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 28 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725941015807-fd14f53b-6c0a-476f-a665-723e64d22c7d.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ol>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ฝ่ายบริการลูกค้าพิเศษ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ยอดถอนสูงสุดต่อวัน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                สิทธิ์เข้าร่วมกิจกรรมต่างๆ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษวันเกิด
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสรักษาระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษเลื่อนระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษตามเทศกาล
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                คืนเงินพิเศษ
                                                            </span>
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(29)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 29 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ระดับ Titanium
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 29 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725944832609-d52edc67-1efe-4d6f-aa57-71cfac26c65d.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ol>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ฝ่ายบริการลูกค้าพิเศษ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ยอดถอนสูงสุดต่อวัน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                สิทธิ์เข้าร่วมกิจกรรมต่างๆ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษวันเกิด
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสรักษาระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษเลื่อนระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษตามเทศกาล
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                คืนเงินพิเศษ
                                                            </span>
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(30)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 30 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ระดับ Diamond
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 30 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725941028335-d9762396-f09b-4d04-82c2-e3cf7e1ae6e3.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ol>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ฝ่ายบริการลูกค้าพิเศษ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ยอดถอนสูงสุดต่อวัน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                สิทธิ์เข้าร่วมกิจกรรมต่างๆ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษวันเกิด
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสรักษาระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษเลื่อนระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษตามเทศกาล
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                คืนเงินพิเศษ
                                                            </span>
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(31)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 31 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ระดับ VVIP
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 31 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725941041926-29262b61-5dd7-4797-867b-1f15626ad0a0.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ol>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ฝ่ายบริการลูกค้าพิเศษ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ยอดถอนสูงสุดต่อวัน
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                สิทธิ์เข้าร่วมกิจกรรมต่างๆ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษวันเกิด
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสรักษาระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษเลื่อนระดับ
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                โบนัสพิเศษตามเทศกาล
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                คืนเงินพิเศษ
                                                            </span>
                                                        </li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    ค่าคืนยอดเสีย
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(32)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 32 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            รายได้ค่าคืนยอดเสียมาจากอะไร?
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 32 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                มาจากการวางเดิมพันทุกประเภท
                                                                (เฉพาะค่ายเกมที่จ่ายค่าคืนยอดเสีย)
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(33)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 33 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            อัตราการจ่ายค่าคืนยอดเสีย %
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 33 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                เปอร์เซ็นต์การจ่ายค่าคอม
                                                                จะขึ้นอยู่กับระดับเลเวลของสมาชิก
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951891662-0c7a9222-2b00-4595-be66-b1e4fefa4aa1.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ค่าคืนยอดเสียจะเเสดงรายได้ยอดที่หน้าโปรไฟล์
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725951928913-cdc39b9d-0528-4cd4-8fc7-139e8cfee60d.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ถอนขั้นต่ำที่{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>100 บาท</strong>
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                ยอดถอนจะอยู่ที่{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff0000"
                                                                }}
                                                            >
                                                                <strong>กระเป๋าหลัก</strong>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                สามารถนำรายได้เข้าเล่น หรือถอนได้เลย
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    คืนยอดเสีย
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(34)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 34 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            กดรับยอดเสียตรงไหน?
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 34 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                ไปที่มุมขวาบนสุด มองหา
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff4917"
                                                                }}
                                                            >
                                                                <strong>กล่องของขวัญ</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725952050740-652b03e0-f98b-405c-afed-bc5edebb171d.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                เลือกโปรโมชั่น{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff4917"
                                                                }}
                                                            >
                                                                <strong>คืนยอดเสีย</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725952079780-222ebed9-3611-48e9-9a96-c5cb20f135ef.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                กดรับโปรโมชั่น{" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#ff4917"
                                                                }}
                                                            >
                                                                <strong>คืนยอดเสีย</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725952104773-bef808a1-74be-4014-a6d2-be334a37b01a.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                กดรับโปรโมชั่น
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#000000"
                                                                }}
                                                            >
                                                                {" "}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "#38761d"
                                                                }}
                                                            >
                                                                <strong>สำเร็จ</strong>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725952123208-1ea4a0a7-c936-428c-b339-cf33511f880c.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full">
                            <div className="px-5">
                                <div className="font-semibold text-sm xs:text-[15px] p-4 pb-0 pt-5">
                                    ปัญหาอินเตอร์เน็ต
                                </div>
                                <div className="my-2.5 bg-[#161616] border border-[#24221E] rounded-xl">
                                    <div onClick={() => this.toggle(35)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 35 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            หากเกิดปัญหาในการเล่นเกม เช่น เกมค้าง, ไม่สามารถเข้าเกมได้{" "}
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 35 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            หากเกิดปัญหาในการเล่นเกม เช่น เกมค้าง, ไม่สามารถเข้าเกมได้
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>ตรวจสอบสัญญาณ </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>WIFI</strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            <strong> </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>ที่ใช้บริการ</strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            สังเกตไอคอนสัญญาณ Wi-Fi บนอุปกรณ์
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725941671367-008c1385-22e0-416a-ab1f-bfdc18ef5b61.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>จำนวนขีด :</strong> ยิ่งมีขีดมากเท่าไหร่
                                                                สัญญาณก็จะยิ่งแรงมากขึ้นเท่านั้น
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>สัญลักษณ์ :</strong>{" "}
                                                                บางครั้งจะมีสัญลักษณ์แสดงประเภทของเครือข่าย เช่น 2.4 GHz
                                                                หรือ 5 GHz
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>ตรวจสอบสัญญาณ</strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            <strong> </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>เครือข่ายมือถือ</strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#000000"
                                                            }}
                                                        >
                                                            <strong> </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>ที่ใช้บริการ</strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            สังเกตไอคอนสัญญาณ
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725941728220-7f0b2a25-bb85-4fac-858a-851764d07f6e.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>จำนวนขีด:</strong> ยิ่งมีขีดมาก
                                                                ยิ่งแสดงว่าสัญญาณแรง
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0, 0%, 100%)"
                                                                }}
                                                            >
                                                                <strong>ประเภทเครือข่าย:</strong> 4G, 5G หรือ 3G
                                                                ควรเลือกใช้เครือข่ายที่เร็วที่สุดเท่าที่พื้นที่รองรับ
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(36)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 36 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            รีเฟรชหน้าเว็บไซต์
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 36 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            บางครั้งปัญหาอาจเกิดจากการที่หน้าเว็บไซต์ไม่ตอบสนอง ลอง
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#666666"
                                                            }}
                                                        >
                                                            {" "}
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "#ff0000"
                                                            }}
                                                        >
                                                            <strong>รีเฟรช🔂 </strong>
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            หน้าเว็บอีกครั้ง
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>วิธีที่ 1</strong>
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>มองหาไอคอน :</strong> มองหาไอคอนรูปลูกศรวงกลม
                                                                หรือรูปวงกลมที่มีลูกศรหมุนอยู่ภายใน
                                                                มักจะอยู่บริเวณด้านบนของหน้าจอใกล้ๆกับแถบ URL
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>แตะที่ไอคอน :</strong> เมื่อเจอไอคอนแล้ว
                                                                ให้แตะที่ไอคอนนั้นเพียงครั้งเดียว
                                                                หน้าเว็บก็จะทำการโหลดใหม่ทันที
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725941941056-9d836e44-8ac5-487c-9b0a-fc58edd96454.png" />
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725941943701-d01e71d6-1c04-4360-b300-fdd2bd928533.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>ผ่านระบบ Android</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725952275977-6a932521-f386-44f9-8dc4-638dc7f13106.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>ผ่านเบราเซอร์ Google Chrome</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725952301763-6063bc0f-1413-475e-9f80-567a9bb99cb0.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0, 0%, 100%)"
                                                            }}
                                                        >
                                                            <strong>ผ่านระบบ iOS (เบราเซอร์ Safari)</strong>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <img src="https://cdn.zabbet.com/XVB1/user-guides/1725942065905-e49a393f-9cb8-4b4b-bbc5-e7fb6c61a5e2.png" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>วิธีที่ 2</strong>
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>ปัดหน้าจอลง :</strong>{" "}
                                                                บางเบราว์เซอร์อนุญาตให้คุณปัดหน้าจอลงจากบนลงล่าง
                                                                เพื่อรีเฟรชหน้าเว็บได้
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>วิธีที่ 3&nbsp;</strong>
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>ใช้ปุ่มเมนู :</strong>{" "}
                                                                บางเบราว์เซอร์อาจซ่อนปุ่มรีเฟรชไว้ในเมนู
                                                                ให้แตะที่ปุ่มเมนู (มักจะเป็น 3 ขีดเรียงกัน) แล้วเลือก
                                                                "รีเฟรช" หรือ "โหลดใหม่"
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>วิธีที่ 4</strong>&nbsp;
                                                        </span>
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    color: "hsl(0,0%,100%)"
                                                                }}
                                                            >
                                                                <strong>(สำหรับPC) ใช้ปุ่ม Hardware :</strong>{" "}
                                                                บางรุ่นอาจมีปุ่มสำหรับรีเฟรชหน้าจอโดยเฉพาะ เช่น ปุ่ม F5
                                                                บนคีย์บอร์ดของแท็บเล็ต
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>เคลียร์ประวัติการเข้าชมหรือเคลียร์แคช</strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            เนื่องจากมีประวัติหรือแคชเยอะเกินไป
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            <strong>เข้าเล่นจากเบราเซอร์ Google Chrome</strong>
                                                        </span>
                                                        <br />
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            บางครั้งลูกค้าเข้าเล่นโดยคลิกลิงก์จากไลน์ ทำให้ไม่เสถียร
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => this.toggle(37)} className="py-[14px] px-2 flex items-center border-t border-[#24221E] first:border-none cursor-pointer transition-all">
                                        <div className={`text-xs ml-2 mr-3 xs:ml-4 transition-transform ${isOpen && keyid == 37 ? "rotate-180" : ""}`} >
                                            <div className="relative w-[9px] h-[9px]">
                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        src="/build/web/igame-index-lobby-wm/img/u4.png"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                    <noscript />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#D4C6A1] font-semibold text-[11px] xs:text-[12px]"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            ติดต่อฝ่ายบริการลูกค้า
                                        </div>
                                    </div>
                                    <div
                                        className="overflow-auto transition-all no-scrollbar"
                                        style={{ maxHeight: keyid == 37 ? 1000 : 0 }}
                                    >
                                        <div className="relative text-xs p-4 css-edno07">
                                            <div className="absolute top-0 left-0 right-0 h-[1px] bg-[#24221E]" />
                                            <div className="text-[12px] xs:text-[10px] sm:text-[10px] md:text-[12px]">
                                                <div className="dangerouslySetInnerHTML">
                                                    <p>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,75%,60%)"
                                                            }}
                                                        >
                                                            ให้แอดมินทำการตรวจสอบ{" "}
                                                        </span>
                                                        <span
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: "hsl(0,0%,100%)"
                                                            }}
                                                        >
                                                            การแก้ไขปัญหาอาจใช้เวลาบ้าง
                                                            ขึ้นอยู่กับความซับซ้อนของปัญหาที่เกิดขึ้น
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>


            </>
        );
    }
}
export default App;
